var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.item.dataFieldName,{tag:"component",attrs:{"item":_vm.item,"row-of-values":_vm.rowOfValues},on:{"appeal-indicator":function($event){return _vm.$emit('appeal-indicator', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }